import React from "react";
import { Route, Switch, Redirect,HashRouter } from "react-router-dom";
import Main from "./View/General/dashboard";
import DashboardGeneral from "./View/General/dashboardGeneral";
import addOrder from "./View/Registration/Order/addOrder";
import addMachine from "./View/Registration/Machine/addMachine";
import addReasonView from "./View/Registration/Reason/addReasonView";
import prelude_ordens from "./View/Prelude/preludeOrders";
import prelude_motivo from "./View/Prelude/preludeReason";
import prelude_machine from "./View/Prelude/preludeMachine";
import prelude_department from "./View/Prelude/preludeDepartment";
import delete_motivo from "./View/Registration/Reason/delReason";
import deleteOP from "./View/Registration/Order/delOrder";
import alter_reason from "./View/Registration/Reason/altReason";
import alter_op from "./View/Registration/Order/altOrder";
//import reportsOrders from "./View/Reports/reportOrders";
//import reportStops from "./View/Reports/reportStops";
import Login from "./View/User/login";
import register from "./View/User/register";
import prelude_work_shift from "./View/Prelude/preludeWorkShift";
import UserPreference from "./View/User/userPreference";
import { isAuthenticated } from "./services/isAuthenticated";
//import reportRefuses from "./View/Reports/reportRefuses";
//import ReportOEE from "./View/Reports/reportOEE";
import ForgotPassword from "./View/User/forgotPassword";
import ResetPassword from "./View/User/resetPassword";
import AltFactory from "./View/Registration/Factory/altFactory";
import prelude_factory from "./View/Prelude/preludeFactory";
import AddRefuseReason from "./View/Registration/RefuseReason/addRefuseReason";
import Details from "./View/General/details";
//import reportAndon from "./View/Reports/reportAndonAction";
import PreludeEmployees from "./View/Prelude/preludeEmployees";
import DashboardTV from "./View/General/dashboardTV";
import prelude_refugo from "./View/Prelude/preludeRefuse";
import prelude_itens from "./View/Prelude/preludeItems"
import prelude_reports from "./View/Prelude/preludeReports";
import AddItems from "./View/Registration/Items/addItems";
import AltItems from "./View/Registration/Items/altItems";
import PreludeParameters from "./View/Prelude/preludeParameters";
import OEEView from "./View/General/oeeView";
import DashboardStops from "./View/Charts/DashboardStops";
import Appointments from "./View/Registration/Appointment/alterAppo"
import prelude_users from "./View/Prelude/preludeUsers";
import PreludeUserPreferences from "./View/Prelude/preludeUserPreferences";



const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => {
  return (
    <HashRouter>
      <Switch>
        <Route exact={true} path="/" component={Login} />
        <Route exact path="/confirmar-email" component={ForgotPassword} />
        <Route exact path="/registro" component={register} />
        <Route exact path="/redefinir-senha" component={ResetPassword} />

        <PrivateRoute exact path="/dashboard" component={Main}></PrivateRoute>
        <PrivateRoute exact path="/dashboard-general" component={DashboardGeneral}></PrivateRoute>
        <PrivateRoute exact path="/oee-view" component={OEEView}></PrivateRoute>
        <PrivateRoute
          exact
          path="/dashboardTV"
          component={DashboardTV}
        ></PrivateRoute>
        <PrivateRoute exact path="/preferencias" component={PreludeUserPreferences} />
        <PrivateRoute exact path="/detalhes/" component={Details} />
        <PrivateRoute exact path="/relatorios/*" component={prelude_reports} />
        <PrivateRoute exact path="/usuarios" component={prelude_users} />

        {/*<PrivateRoute exact path="/relatorios/andon" component={reportAndon} />
        <PrivateRoute exact path="/relatorios/oee" component={ReportOEE} />
        <PrivateRoute
          exact
          path="/relatorios/ordens"
          component={reportsOrders}
        />
        <PrivateRoute
          exact
          path="/relatorios/refugos"
          component={reportRefuses}
        />
        <PrivateRoute
          exact
          path="/relatorios/paradas"
          component={reportStops}
        />
        <PrivateRoute
          exact
          path="/relatorios/producao/:id"
          component={reportProduction}
        />*/}
        <PrivateRoute
          exact
          path="/motivos/cadastro-motivos"
          component={addReasonView}
        />
        <PrivateRoute
          exact
          path="/ordens/cadastro-ordens"
          component={addOrder}
        />
        <PrivateRoute exact path="/cadastro-maquina" component={addMachine} />

        <PrivateRoute
          exact
          path="/motivos/alt-motivo"
          component={alter_reason}
        />
        <PrivateRoute exact path="/ordens/alt-op" component={alter_op} />
        <PrivateRoute exact path="/plantas/alt-planta" component={AltFactory} />

        <PrivateRoute
          exact
          path="/motivos/del-motivo"
          component={delete_motivo}
        />
        <PrivateRoute exact path="/ordens/del-op" component={deleteOP} />

        <PrivateRoute exact path="/ordens" component={prelude_ordens} />
        <PrivateRoute exact path="/refugos" component={prelude_refugo} />
        <PrivateRoute exact path="/maquinas" component={prelude_machine} />
        <PrivateRoute exact path="/turnos" component={prelude_work_shift} />
        <PrivateRoute exact path="/setores" component={prelude_department} />
        <PrivateRoute exact path="/plantas" component={prelude_factory} />
        <PrivateRoute exact path="/motivos" component={prelude_motivo} />
        <PrivateRoute exact path="/funcionarios" component={PreludeEmployees} />
        <PrivateRoute exact path="/motivos-refugos" component={AddRefuseReason}/>

        <PrivateRoute exact path="/itens" component={prelude_itens} />
        <PrivateRoute exact path="/itens/add-itens" component={AddItems} />
        <PrivateRoute exact path="/itens/alt-itens" component={AltItems} />
        <PrivateRoute exact path="/apontamentos" component={Appointments} />
        <PrivateRoute exact path="/parametros" component={PreludeParameters} />
        <PrivateRoute exact path="/dashboard-stops" component={DashboardStops} />

        <PrivateRoute
          path="*"
          component={() => (
            <div>
              <h1 style={{ color: "black" }}>Página não encontrada</h1>
              <a href="#/dashboard" style={{ marginLeft: 10 }}>
                Voltar ao Dashboard
              </a>
            </div>
          )}
        />
      </Switch>
    </HashRouter>
  );
};

export default Routes;
